import { TemplateViewerDialog } from 'apps/wrapper/src/components/shared/template/template-viewer/template-viewer-dialog';
import { useEventBus } from 'apps/wrapper/src/hooks/use-event-bus';
import { EventViewEmailCommunication } from 'apps/wrapper/src/types/event-bus';
import { FC, useEffect, useState } from 'react';

export const ViewEmailCommunicationListener: FC = () => {
  const { listen } = useEventBus();
  const [communicationId, setCommunicationId] = useState<string>();

  useEffect(
    () =>
      listen('view-email-communication', (event) => {
        const { data } = event as EventViewEmailCommunication;
        setCommunicationId(data.communicationId);
      }),
    []
  );

  return (
    <>
      <TemplateViewerDialog
        open={!!communicationId}
        communicationId={communicationId}
        onClose={() => setCommunicationId(undefined)}
      />
    </>
  );
};
